import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Snackbar,
  Stack,
  Typography
} from "@mui/material";

// Panel Auto-Refresh - the 30 second countdown notification.
//
// Deliberately a non-blocking Snackbar rather than a Modal: the whole point of the
// warning is to give the user time to go and save whatever they were working on, so
// it must not trap focus or stop them from using the page underneath it. This is also
// the only place the countdown is rendered - the scheduled window, a missed window
// and an admin-forced refresh all land here with the same 30 second logic.
export default function RefreshCountdownSnackbar({
  open,
  secondsLeft,
  warningSeconds,
  title,
  body,
  buttonLabel,
  onRefresh
}) {
  const total = Math.max(warningSeconds || 30, 1);
  const left = Math.max(secondsLeft || 0, 0);
  const percent = Math.min(100, (left / total) * 100);

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      sx={{ zIndex: (theme) => theme.zIndex.snackbar + 100 }}
    >
      <Paper
        elevation={12}
        sx={{
          borderTop: "4px solid",
          borderColor: "primary.main",
          px: 2.5,
          py: 2,
          maxWidth: 620,
          width: "100%"
        }}
      >
        <Stack direction="row" spacing={2} alignItems="center">
          <Box sx={{ position: "relative", display: "inline-flex", flexShrink: 0 }}>
            <CircularProgress variant="determinate" value={percent} size={54} thickness={4} />
            <Box
              sx={{
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                position: "absolute",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <Typography variant="body2" fontWeight={700}>
                {left}
              </Typography>
            </Box>
          </Box>

          <Box sx={{ flexGrow: 1, minWidth: 0 }}>
            <Typography variant="subtitle1" fontWeight={600}>
              {String(title || "").replace("{seconds}", left)}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
              {body}
            </Typography>
          </Box>

          <Button variant="contained" onClick={onRefresh} sx={{ flexShrink: 0, whiteSpace: "nowrap" }}>
            {buttonLabel}
          </Button>
        </Stack>
      </Paper>
    </Snackbar>
  );
}
